import { jsx as _jsx } from "react/jsx-runtime";
import { RouterProvider } from 'react-router-dom';
import { router } from './routes/AppRoutes';
import './ui/modules/shared/helpers/setViewportProperty';
export default function App() {
    return _jsx(RouterProvider, { router: router });
}
